import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { PromisableAction } from "models/promisable-action";
import { useAppDispatch } from "store/hooks";

export function useDispatchToPromise() {
    const dispatch = useAppDispatch();

    return <T extends PromisableAction>(action: ActionCreatorWithPayload<T>, payload: T) => {
        return new Promise<void>((resolve, reject) => {
            dispatch(action({
                ...payload,
                async onSuccess() {
                    await payload?.onSuccess?.();
                    resolve();
                },
                async onFailed() {
                    await payload?.onFailed?.();
                    reject();
                }
            }));
        })
    }
}